import React, { useEffect, useMemo, useState } from 'react';

const FACEBOOK_PAGE_URL = 'https://www.facebook.com/banguodontoclinica';
const POSTS_ENDPOINT = process.env.REACT_APP_FACEBOOK_POSTS_ENDPOINT || '/api/facebook-posts';

const normalizePosts = (payload) => {
  const list = Array.isArray(payload) ? payload : payload?.posts || payload?.data || [];

  return list.slice(0, 3).map((post) => ({
    id: post.id,
    message: post.message || post.story || 'Publicação recente da Bangu Odonto Clínica.',
    image: post.full_picture || post.picture || post.attachments?.data?.[0]?.media?.image?.src,
    url: post.permalink_url || post.url || FACEBOOK_PAGE_URL,
    createdTime: post.created_time,
  }));
};

const formatDate = (date) => {
  if (!date) return 'Facebook';

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date));
};

const FacebookPosts = () => {
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;

    fetch(POSTS_ENDPOINT)
      .then((response) => {
        if (!response.ok) throw new Error('Facebook posts unavailable');
        return response.json();
      })
      .then((payload) => {
        if (!active) return;
        const nextPosts = normalizePosts(payload);
        setPosts(nextPosts);
        setStatus(nextPosts.length ? 'ready' : 'empty');
      })
      .catch(() => {
        if (active) setStatus('error');
      });

    return () => {
      active = false;
    };
  }, []);

  const canShowPosts = status === 'ready' && posts.length > 0;
  const placeholders = useMemo(() => Array.from({ length: 3 }), []);

  return (
    <>
      <div className="divider" id="facebook">
        <span><span className="dot"></span> 05 / Facebook</span>
        <span>Últimas novidades</span>
      </div>

      <section className="facebook-posts">
        <div className="facebook-head">
          <h2 className="display">
            Acompanhe a clínica<br />também no <em>Facebook</em>.
          </h2>
          <a href={FACEBOOK_PAGE_URL} target="_blank" rel="noopener noreferrer" className="facebook-page-link">
            Ver página
            <span>↗</span>
          </a>
        </div>

        {canShowPosts ? (
          <div className="facebook-grid">
            {posts.map((post) => (
              <article className="facebook-card" key={post.id || post.url}>
                {post.image && (
                  <a href={post.url} target="_blank" rel="noopener noreferrer" className="facebook-card-media">
                    <img src={post.image} alt="" />
                  </a>
                )}
                <div className="facebook-card-body">
                  <div className="facebook-card-date">{formatDate(post.createdTime)}</div>
                  <p>{post.message}</p>
                  <a href={post.url} target="_blank" rel="noopener noreferrer">
                    Abrir publicação
                  </a>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="facebook-grid facebook-grid-fallback">
            {placeholders.map((_, index) => (
              <article className="facebook-card facebook-card-empty" key={index}>
                <div className="facebook-card-body">
                  <div className="facebook-card-date">Facebook</div>
                  <p>As publicações recentes aparecerão aqui assim que a integração com a Graph API estiver conectada.</p>
                  <a href={FACEBOOK_PAGE_URL} target="_blank" rel="noopener noreferrer">
                    Ver novidades
                  </a>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </>
  );
};

export default FacebookPosts;
